// https://developer.work.weixin.qq.com/document/path/98268
// 企微web登录组件挂载的元素id
export const WECOM_QR_CODE_PANEL_MOUNT_ID = 'wecom_login_panel';
